// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout';
import LandingPage from './components/landing/LandingPage';
import About from './components/static/About';
import Guide from './components/static/Guide';
import PrivacyPolicy from './components/static/PrivacyPolicy';
import Terms from './components/static/Terms';
import PDFReader from './components/services/tools/pdf/PDFReader';
import ScrollToTop from './components/common/ScrollToTop';
import ServiceDashboard from './components/services/dashboard/ServiceDashboard';
import AssetPurchase from './components/services/accounting/services/AssetPurchase';
import ExpenseManagement from './components/services/accounting/services/ExpenseManagement';
import FinancialActivities from './components/services/accounting/services/FinancialActivities';
import SalesPurchase from './components/services/accounting/services/SalesPurchase';
import EmailWriter from './components/services/tools/email/EmailWriter';
import SajuService from './components/services/fortune/saju/SajuService';
import ReportWriter from './components/services/tools/report/ReportWriter';

// 유틸리티 도구 import
import TextAnalyzer from './components/services/tools/utilities/TextAnalyzer';
import UnitConverter from './components/services/tools/utilities/UnitConverter';
import DateCalculator from './components/services/tools/utilities/DateCalculator';
import QRCodeGenerator from './components/services/tools/utilities/QRCodeGenerator';

function App() {
  console.log('App 컴포넌트 렌더링');

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/services" element={<ServiceDashboard />} />
            <Route path="/services/asset-purchase" element={<AssetPurchase />} />
            <Route path="/services/expense-management" element={<ExpenseManagement />} />
            <Route path="/services/financial-activities" element={<FinancialActivities />} />
            <Route path="/services/sales-purchase" element={<SalesPurchase />} />
            <Route path="/tools/pdf-reader" element={<PDFReader />} />
            <Route path="/about" element={<About />} />
            <Route path="/guide" element={<Guide />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/tools/email-writer" element={<EmailWriter />} />
            <Route path="/services/fortune/saju" element={<SajuService />} />
            <Route path="/services/report" element={<ReportWriter />} />
            <Route path="/services/tools/utilities/text-analyzer" element={<TextAnalyzer />} />
            <Route path="/services/tools/utilities/unit-converter" element={<UnitConverter />} />
            <Route path="/services/tools/utilities/date-calculator" element={<DateCalculator />} />
            <Route path="/services/tools/utilities/qr-generator" element={<QRCodeGenerator />} />
          </Routes>
        </Layout>
      </Router>
    </HelmetProvider>
  );
}

export default App;